"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getPhoneErrorContent = void 0;
var phoneErrors_1 = require("./phoneErrors");
var commonweb_utils_1 = require("commonweb-utils");
function getPhoneErrorContent(error, content) {
    var errorStatusCode = commonweb_utils_1.objectUtils.safeGet(error, "error.statusCode") || 500, errorContent = "", code = "";
    if (errorStatusCode >= 400 && errorStatusCode < 500) {
        var errorObj = error && error.error, errorKey = errorObj && errorObj.errorKey, redirectLink = errorObj && errorObj.redirectLink, returnLink = errorObj && errorObj.returnLink;
        code = phoneErrors_1.errorCodes[errorKey];
        if (errorKey === "STEPUP_AUTH" && redirectLink) {
            var linkToRedirect = redirectLink;
            linkToRedirect = linkToRedirect.substring(linkToRedirect.indexOf("/authflow"), linkToRedirect.length);
            linkToRedirect = linkToRedirect + "&returnUri=" + returnLink;
            return linkToRedirect;
        }
        var errorMsg = code ? content.phones.error[code] : false;
        errorContent = errorMsg ? errorMsg : content.common.genericServerError;
    }
    else {
        errorContent = content.common.genericServerError;
    }
    if (code === "alreadyExists") {
        return code.concat("-").concat(errorContent);
    }
    return errorContent;
}
exports.getPhoneErrorContent = getPhoneErrorContent;
